/**
 * MapLocationEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { MapEntity } from "../MapEntity";
import { BugEntity } from "../BugEntity";
import { MapLocationEntity } from "../MapLocationEntity";
declare global {
    interface EntityTypeMap {
        MapLocation: MapLocationEntity;
    }
}
export abstract class MapLocationGeneratedEntity extends BaseEntity {
    public abstract mapLocationId: string;
    public abstract templateId: string | null;
    public abstract bimGuid: string;
    public abstract type: string;
    public abstract name: string | null;
    public abstract map: MapEntity;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
}
